/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_TealInputs */

const en_booking_color_teal = /** @type {(inputs: Booking_Color_TealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teal`)
};

const pl_booking_color_teal = /** @type {(inputs: Booking_Color_TealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morski`)
};

/**
* | output |
* | --- |
* | "Teal" |
*
* @param {Booking_Color_TealInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_teal = /** @type {((inputs?: Booking_Color_TealInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_TealInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_teal(inputs)
	return en_booking_color_teal(inputs)
});